export default __webpack_public_path__ + "images/orlo404.png";